import Pagination from 'components/common/Pagination';
import useNotificationTable from 'hooks/notification/useNotificationTable';
import useNotificationTableItem from 'hooks/notification/useNotificationTableItem';
import styled, { css } from 'styled-components';

const NotificationTableItem = ({ notification }) => {
  const { onUpdate } = useNotificationTableItem();

  return (
    <NotificationTableItemBlock onClick={() => onUpdate(notification.id)}>
      <div className="cell-s">
        <NotiLight isRead={notification.isRead} />
      </div>
      <div className="cell">
        <div className="top-wrapper">
          <div className="noti-title">{notification.title}</div>
          <div className="noticedAt">{notification.noticedAt}</div>
        </div>
        <div className="noti-body">{notification.body}</div>
      </div>
    </NotificationTableItemBlock>
  );
};

const NotificationTableItemBlock = styled.div`
  padding-bottom: 1rem;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  margin-bottom: 1rem;
  cursor: pointer;
  &:last-child {
    margin-bottom: 0;
  }

  .cell-s {
    width: 10%;
    margin-right: 20px;
    display: flex;
    justify-content: center;
  }

  .cell {
    width: 100%;
  }

  .top-wrapper {
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
  }

  .noti-title {
    width: 100%;
    font-weight: 500;
  }

  .noticedAt {
    width: 200px;
    text-align: end;
    font-size: 13px;
  }

  .noti-body {
    font-size: 14px;
  }
`;

const NotiLight = styled.div`
  width: 12px;
  height: 12px;
  ${props =>
    props.isRead === 0 &&
    css`
      background: red;
      border-radius: 50px;
    `}
`;

const NotificationTable = () => {
  const { currentPage, setCurrentPage, count, notificationList } =
    useNotificationTable();

  return (
    <NotificationTableBlock>
      {notificationList?.map(notification => (
        <NotificationTableItem
          key={notification.id}
          notification={notification}
        />
      ))}
      <Pagination
        totalPage={Math.ceil(count / 10)}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </NotificationTableBlock>
  );
};

export default NotificationTable;

const NotificationTableBlock = styled.div`
  margin-top: 1rem;
  margin-bottom: 2rem;
  padding: 2rem;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.1);
`;
